/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown> }} Partner_Billing_Board_Next_Run_InInputs */



/**
* | output |
* | --- |
* | "next run in {days} days" |
*
* @param {Partner_Billing_Board_Next_Run_InInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_next_run_in = /** @type {((inputs: Partner_Billing_Board_Next_Run_InInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Next_Run_InInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`nächster Lauf in ${i?.days} Tagen`)
	return /** @type {LocalizedString} */ (`next run in ${i?.days} days`)
});